import { createAction } from '@reduxjs/toolkit';

import { get, patch, post, put } from './axios-request-actions';

import {
  API_GET_CURRENT_USER,
  API_SIGN_UP,
  API_GET_CURRENT_SPECIFIC_SITE,
  API_CONFIRM_USER,
  API_USER_PASSWORD,
  API_CREATE_MEMBERSHIP,
  API_VISIT_ONBOARDING_STEP,
  API_COMPLETE_REGISTRATION,
} from 'constants/api-paths';
import {
  CURRENT_USER,
  SIGN_UP,
  USER_SPECIFIC_SITE,
  CONFIRM_USER,
  USER_RESET_PASSWORD,
  USER_JOIN_AS_MEMBER,
  USER_JOIN_AS_EXPERT,
  ActionClearType,
  VISIT_ONBOARDING_STEP,
  COMPLETE_REGISTRATION,
  UPDATE_CURRENT_USER_AVATAR,
} from 'constants/redux-actions';

const signUp = (user) => post(SIGN_UP, API_SIGN_UP, { user });

const getCurrentUser = (siteId) => get(CURRENT_USER, API_GET_CURRENT_USER, { siteId }, { data: null });

const getSpecificForSite = (siteId) =>
  get(USER_SPECIFIC_SITE, API_GET_CURRENT_SPECIFIC_SITE, { siteId }, { data: null });

const confirmUser = (token) => get(CONFIRM_USER, API_CONFIRM_USER, { token }, { data: null });

const resetPassword = (resetPasswordToken, password, passwordConfirmation) =>
  put(USER_RESET_PASSWORD, API_USER_PASSWORD, { user: { password, passwordConfirmation, resetPasswordToken } });

const joinAsMember = (siteId) => post(USER_JOIN_AS_MEMBER, API_CREATE_MEMBERSHIP, { siteId, membership: {} });

const joinAsExpert = (siteId) =>
  post(USER_JOIN_AS_EXPERT, API_CREATE_MEMBERSHIP, { siteId, membership: { creatingExpertProfile: true } });

const clearMembership = () => createAction(ActionClearType(USER_SPECIFIC_SITE))();

const visitOnboardingStep = (siteId, step) => patch(VISIT_ONBOARDING_STEP, API_VISIT_ONBOARDING_STEP, { siteId, step });

const completeRegistration = (siteId) => patch(COMPLETE_REGISTRATION, API_COMPLETE_REGISTRATION, { siteId });

const updateAvatar = createAction(UPDATE_CURRENT_USER_AVATAR);

const userActions = {
  signUp,
  getCurrentUser,
  getSpecificForSite,
  confirmUser,
  resetPassword,
  joinAsMember,
  joinAsExpert,
  clearMembership,
  visitOnboardingStep,
  completeRegistration,
  updateAvatar,
};

export default userActions;
